export interface GalleryCategory {
  name: string
  tag: string
  caption: string
  image: string
  featured?: boolean
}

const IMAGES = {
  herbario:
    'https://cdn.magicpatterns.com/uploads/4S2sRMB4G9EuhZ2FSyLY1Y/cuadro_herbario.jpg',
  resina:
    'https://cdn.magicpatterns.com/uploads/jS7XoHU9udkvzvkX59EUtC/joyeria_en_resina.jpg',
  velas: 'https://cdn.magicpatterns.com/uploads/5oxanzMC28n1HE3mkg4qBj/velas.jpg',
  tarjetas:
    'https://cdn.magicpatterns.com/uploads/noAhsw1BJC73dzpFRpV461/tarejtas_de_regalo.jpg',
  marcapaginas:
    'https://cdn.magicpatterns.com/uploads/4tP5xiJCsJbWB1uhn7t5qG/marcapaginas.jpg',
  cuadros:
    'https://cdn.magicpatterns.com/uploads/fE2VgWMhtNXg5oj1eFgwXU/cuadros_botanicos.jpg',
}

export const galleryImages = IMAGES

export const galleryCategories: GalleryCategory[] = [
  {
    name: 'Framed herbarium',
    tag: 'Botanical arrangement',
    caption: 'Hand-labeled species on linen in a brass frame',
    image: IMAGES.herbario,
    featured: true,
  },
  {
    name: 'Botanical wall art',
    tag: 'Floral frame',
    caption: 'A circular arrangement of petals and daisies',
    image: IMAGES.cuadros,
  },
  {
    name: 'Pressed flower bookmarks',
    tag: 'Gift idea',
    caption: 'Daisy, fern and blue blooms with a silk tassel',
    image: IMAGES.marcapaginas,
  },
  {
    name: 'Floral greeting cards',
    tag: 'Floral card',
    caption: 'Cotton and kraft paper finished with a ribbon bow',
    image: IMAGES.tarjetas,
  },
  {
    name: 'Decorated candles',
    tag: 'Decor project',
    caption: 'Petals and ferns set right into the wax',
    image: IMAGES.velas,
  },
  {
    name: 'Pendants & accessories',
    tag: 'Piece to sell',
    caption: 'Pressed flowers sealed with delicate gold detailing',
    image: IMAGES.resina,
  },
]

export interface GalleryPhoto {
  alt: string
  tag: string
  image: string
}

export const galleryCarousel: GalleryPhoto[] = [
  {
    alt: 'Framed herbarium with hand-labeled species in a brass frame',
    tag: 'Botanical arrangement',
    image: IMAGES.herbario,
  },
  {
    alt: 'Botanical wall art with pink petals and daisies in a wooden frame',
    tag: 'Floral frame',
    image: IMAGES.cuadros,
  },
  {
    alt: 'Pressed flower bookmarks with daisy, fern and blue blooms',
    tag: 'Gift idea',
    image: IMAGES.marcapaginas,
  },
  {
    alt: 'Greeting cards with pressed flowers and kraft envelopes',
    tag: 'Floral card',
    image: IMAGES.tarjetas,
  },
  {
    alt: 'Candles decorated with pressed flowers and ferns',
    tag: 'Decor project',
    image: IMAGES.velas,
  },
  {
    alt: 'Pressed flower pendants on a gold chain',
    tag: 'Piece to sell',
    image: IMAGES.resina,
  },
]
